jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })


  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();

  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });

  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });

    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');

    });
  });




document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer is visible → hide sticky form
            stickyForm.style.display = "none";
          } else {
            // Footer is not visible → show sticky form
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0, // trigger as soon as footer touches viewport
      }
    );

    observer.observe(footer);
  }
});


/* ===== Kaching Bundles Deep-Link (Startseite -> Produktseite) ===== */

/* (A) Startseite: Highlight-Bar Bundle-Kacheln anhand ihres Labels (".. PACK ..")
   automatisch mit ?kb=<Menge> verlinken. Farb-Kacheln (ohne "pack") bleiben unverändert. */
(function () {
  function augment() {
    var links = document.querySelectorAll('a[class*="ai-product-highlight-link-"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.href || a.getAttribute('data-kb-done')) continue;
      var labelEl = a.querySelector('[class*="ai-product-highlight-label-"]');
      var txt = (labelEl ? labelEl.textContent : a.textContent) || '';
      var m = txt.match(/(\d+)\s*-?\s*pack/i);
      if (!m) continue;
      try {
        var u = new URL(a.href, window.location.origin);
        if (!u.searchParams.get('kb')) {
          u.searchParams.set('kb', m[1]);
          a.href = u.toString();
        }
        a.setAttribute('data-kb-done', '1');
      } catch (e) {}
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', augment);
  } else {
    augment();
  }
  document.addEventListener('shopify:section:load', augment);
})();

/* (B) Produktseite: ?kb=<Menge> liest die passende Kaching-Bundle-Bar aus der
   App-Konfiguration und wählt sie im Widget vor. */
(function () {
  var kbParam = new URLSearchParams(window.location.search).get('kb');
  if (!kbParam) return;
  var kbQty = parseInt(kbParam, 10);
  if (isNaN(kbQty)) return;
  kbQty = String(kbQty);

  // Ziel-Bar-ID aus der Kaching-Konfiguration im Seiten-HTML (Menge -> dealBarId)
  function resolveTargetBarId() {
    var scripts = document.querySelectorAll('script.kaching-bundles-deal-block-settings');
    for (var s = 0; s < scripts.length; s++) {
      try {
        var cfg = JSON.parse(scripts[s].textContent);
        var bars = (cfg && cfg.dealBars) || [];
        for (var b = 0; b < bars.length; b++) {
          if (String(bars[b].quantity) === kbQty) return bars[b].id;
        }
      } catch (e) {}
    }
    return null;
  }

  // Tiefensuche inkl. offener Shadow-DOMs
  function deepQueryAll(selector, root, out) {
    out = out || [];
    root = root || document;
    try {
      root.querySelectorAll(selector).forEach(function (el) { out.push(el); });
    } catch (e) {}
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) deepQueryAll(selector, all[i].shadowRoot, out);
    }
    return out;
  }

  function isSelected(el) {
    if (!el) return false;
    if (el.getAttribute && el.getAttribute('aria-checked') === 'true') return true;
    if (el.querySelector) {
      if (el.querySelector('[aria-checked="true"]')) return true;
      var r = el.querySelector('input[type="radio"]');
      if (r && r.checked) return true;
    }
    if (typeof el.className === 'string' && /selected|active|checked/i.test(el.className)) return true;
    return false;
  }

  var done = false;
  function trySelect() {
    if (done) return true;
    var targetId = resolveTargetBarId();
    if (!targetId) return false;
    var candidates = deepQueryAll('[data-deal-bar-id="' + targetId + '"]');
    if (!candidates.length) return false;

    var barEl = candidates[0];
    // Ist die Ziel-Bar bereits aktiv? Dann nichts tun (verhindert versehentliches Umschalten).
    if (isSelected(barEl)) { done = true; return true; }

    // Bevorzugt das Radio-Input anklicken (Radios schalten sich nicht wieder ab).
    var radio = barEl.querySelector && barEl.querySelector('input[type="radio"]');
    var clickable = radio || barEl;
    try { clickable.click(); } catch (e) {}
    done = true;
    return true;
  }

  function start() {
    if (trySelect()) return;
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      if (trySelect() || attempts > 60) clearInterval(iv); // ~15s bei 250ms
    }, 250);
    try {
      var mo = new MutationObserver(function () { if (trySelect()) mo.disconnect(); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 16000);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();